// @flow

import * as React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ReactForm, ReactFormField } from "@adrenalin/react-form";

import convertToQueryString from "../../utils/convertToQueryString";
import clearForm from "../../utils/clearForm";
import Accordion from "../molecules/Accordion";
import Modal from "../organisms/Modal";
import Button from "../atoms/Button";
import TextButton from "../atoms/TextButton";

type PropsType = {
    active?: boolean,
    filters: [],
    heading?: string,
    onClose?: Function,
};

const FiltersModal = (props: PropsType): React.Node => {
    const filterFormRef = React.useRef(null);
    const history = useHistory();
    const { query } = useSelector((state: any): any => state.router.location);
    const [initialParams, setInitialParams] = React.useState({});
    const [formCleared, setFormCleared] = React.useState(false);

    React.useEffect(() => {
        setInitialParams(query);
        setFormCleared(false);
    }, [props.active, query]);

    const handleFiltersSubmit = (event: any): any => {
        if (filterFormRef.current && filterFormRef.current.formRef.current) {
            // get FormData of filters form and convert to json object
            const formData = new FormData(
                filterFormRef.current.formRef.current
            );

            let jsonFilters = {};
            for (const [key, value] of formData.entries()) {
                if (typeof value === "string") {
                    jsonFilters[key] = jsonFilters[key]
                        ? `${jsonFilters[key]},` + encodeURIComponent(value)
                        : encodeURIComponent(value);
                }
            }

            // push any existing search querys so it's included
            if (query.search) {
                jsonFilters.search = query.search;
            }
            if (query.q) {
                jsonFilters.q = query.q;
            }

            const queryStringParams = convertToQueryString(jsonFilters);

            if (props.onClose) {
                // close modal and push route to walk listing page with new filter params
                props.onClose();
                setTimeout(() => {
                    // delay redirect to allow for modal to close
                    history.push(
                        `${document.location.pathname}?${queryStringParams}`
                    );
                }, 500);
            }
        }
    };

    const handleModalReset = () => {
        if (filterFormRef.current && filterFormRef.current.formRef.current) {
            setFormCleared(true);
            // clear all form fields
            clearForm(filterFormRef.current.formRef.current, "sorting");
        }
    };

    const isFilterOptionActive = (optionKey: string, filterOption: any) => {
        const initialParamKeyValuesArray = decodeURIComponent(
            initialParams[optionKey]
        ).split(",");

        const filterActive = initialParams[optionKey]
            ? initialParamKeyValuesArray.includes(
                  encodeURIComponent(filterOption.key)
              )
            : filterOption.default || false;

        return filterActive;
    };

    return (
        <>
            <Modal
                className="listing__filters-modal"
                aside={true}
                active={props.active}
                onClose={() => {
                    if (props.onClose) {
                        props.onClose();
                    }
                }}
                onOverlayClick={props.onClose}
            >
                <Modal.Header>{props.heading}</Modal.Header>
                <Modal.Content>
                    <div className="container-fluid">
                        <ReactForm ref={filterFormRef} onSuccess={() => {}}>
                            {props.filters.map(
                                (filter: any, index: number): React.Node => (
                                    <Accordion
                                        key={index}
                                        small={true}
                                        title={
                                            <>
                                                <div className="listing__filters-modal__heading">
                                                    {filter.label}
                                                </div>
                                                <div className="listing__filters-list">
                                                    {filter.options.map(
                                                        (
                                                            filterOption: {
                                                                label: string,
                                                            },
                                                            index: number
                                                        ): React.Node => {
                                                            if (
                                                                isFilterOptionActive(
                                                                    filter.option_key,
                                                                    filterOption
                                                                ) &&
                                                                !formCleared
                                                            ) {
                                                                return (
                                                                    <span
                                                                        key={
                                                                            index
                                                                        }
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: filterOption.label,
                                                                        }}
                                                                    ></span>
                                                                );
                                                            } else {
                                                                return null;
                                                            }
                                                        }
                                                    )}
                                                </div>
                                            </>
                                        }
                                    >
                                        <>
                                            {filter.options.map(
                                                (
                                                    filterOption: {
                                                        label: string,
                                                        key: any,
                                                    },
                                                    index: number
                                                ): React.Node => {
                                                    return (
                                                        <ReactFormField
                                                            className="react-form__field--reverse"
                                                            key={index}
                                                            sorting={
                                                                filter.is_sorting
                                                                    ? "true"
                                                                    : ""
                                                            }
                                                            type={
                                                                filter.option_type ===
                                                                "multiple"
                                                                    ? "checkbox"
                                                                    : "radio"
                                                            }
                                                            label={
                                                                filterOption.label
                                                            }
                                                            name={
                                                                filter.option_key
                                                            }
                                                            value={
                                                                filterOption.key
                                                            }
                                                            defaultChecked={isFilterOptionActive(
                                                                filter.option_key,
                                                                filterOption
                                                            )}
                                                        />
                                                    );
                                                }
                                            )}
                                        </>
                                    </Accordion>
                                )
                            )}

                            <br />
                            <br />

                            <Button
                                type="submit"
                                styles={["green"]}
                                aria-label="Done"
                                onClick={handleFiltersSubmit}
                            >
                                Done
                            </Button>
                        </ReactForm>

                        <p
                            className="center-xs"
                            style={{ display: "flex", marginTop: "32px" }}
                        >
                            <TextButton
                                aria-label="Clear all flters"
                                onClick={handleModalReset}
                            >
                                Clear All
                            </TextButton>
                        </p>
                    </div>
                </Modal.Content>
            </Modal>
        </>
    );
};

export default FiltersModal;
